export const SET_CERTIFICATE_TYPES = 'SET_CERTIFICATE_TYPES';
export const SET_PURCHASED_CERTIFICATES = 'SET_PURCHASED_CERTIFICATES';
